import { USER_ROLES } from "@/consts";

const accessRoles = [USER_ROLES.STORE_MANAGER];

export default {
  path: "store-manager",
  component: (resolve) => require(["@/views/StoreManager/Index"], resolve),
  hidden: true,
  name: "StoreManagerIndex",
  meta: {},
  children: [
    {
      path: "dashboard",
      component: () =>
        import(
          /* webpackChunkName: "store-manager-dashboard" */ "@/views/StoreManager/Dashboard"
        ),
      name: "StoreManagerDashboard",
      meta: {
        title: "店铺业绩",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
    {
      path: "customers",
      component: () =>
        import(
          /* webpackChunkName: "store-manager-customer" */ "@/views/StoreManager/Customers"
        ),
      name: "StoreManagerCustomers",
      meta: {
        title: "我的顾客",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
    {
      path: "sales",
      component: () =>
        import(
          /* webpackChunkName: "store-manager-sales" */ "@/views/StoreManager/Salers"
        ),
      name: "StoreManagerSales",
      meta: {
        title: "店员管理",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
    {
      path: "orders",
      component: () =>
        import(
          /* webpackChunkName: "store-manager-orders" */ "@/views/StoreManager/Orders"
        ),
      name: "StoreManagerOrders",
      meta: {
        title: "全部订单",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
    {
      path: "my",
      component: () =>
        import(
          /* webpackChunkName: "store-manager-my" */ "@/views/StoreManager/Mine"
        ),
      name: "StoreManagerMy",
      meta: {
        title: "我的",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
  ],
};
